<template>
  <footer class="app-footer">
    <div class="app-footer__top row">
      <div class="col-lg-3 col-sm-6 col-xs-12">
        <img src="@/assets/img/logo.svg" alt="Venda e Ganhe Logo" />
      </div>
      <div class="col-lg-3 col-sm-6 col-xs-12">
        <b-icon icon="phone"></b-icon>
        <div class="text">
          <p>(41) 3114-7282</p>
          <p>Segunda a Sexta-feira</p>
          <p>Das 9 às 18 horas</p>
        </div>
      </div>
      <div class="col-lg-3 col-sm-6 col-xs-12">
        <b-icon icon="whatsapp"></b-icon>
        <div class="text">
          <p>(41) 99267-8525</p>
        </div>
      </div>
      <div class="col-lg-3 col-sm-6 col-xs-12">
        <b-icon icon="email"></b-icon>
        <div class="text">
          <p>atendimento@clubevendaeganhe.com.br</p>
        </div>
      </div>
    </div>
    <div class="app-footer__bottom row">
      <div class="col-xs-12 col-lg-6 text">
        <h1>Seu Clube de Prêmios!</h1>
        <p>
          O Clube Venda e Ganhe é um portal para você acompanhar sua pontuação e
          converter em produtos ou dinheiro.
        </p>
        <div class="copyright">
          Copyright - 2020 - Todos os direitos reservados a Gofast Consultoria
        </div>
      </div>
      <div v-if="isAuthenticated" class="col-xs-12 col-lg-6 menus">
        <ol v-for="(chunk, index) in menuChunks" :key="`m-${index}`">
          <li v-for="(menu, index) in chunk" :key="`s-${index}`">
            <router-link
              tag="span"
              :to="{ name: menu.route ? menu.route : menu.children[0].route }"
            >
              {{ menu.title }}
            </router-link>
          </li>
        </ol>
      </div>
    </div>
  </footer>
</template>

<script>
import MENUS from '@/constants/menus.constant';
import chunk from 'lodash/chunk';

export default {
  name: 'app-footer',
  data: () => {
    return {
      menuChunks: chunk(MENUS, 4),
    };
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
  },
};
</script>

<style lang="scss" scoped>
.app-footer {
  &__top {
    min-height: var(--footer-top-height);
    background: var(--color-light-grey);
    padding: 0 8vw;

    > div {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 16px 0;

      .icon {
        color: var(--color-primary);
        margin-right: 16px;
      }

      .text {
        text-align: left;
        p {
          font-size: 0.9em;

          &:first-child {
            font-weight: 500;
          }

          &:not(:first-child) {
            color: var(--text-color-light);
          }
        }
      }
    }
  }

  &__bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 8vw;
    color: #fff;
    min-height: var(--footer-bottom-height);
    background: var(--color-dark-grey);

    .text {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
      padding: 24px 0;

      h1 {
        font-size: 1.8em;
        margin-bottom: 16px;
        font-weight: 400;
      }

      p {
        margin: 0;
        font-weight: 4;
      }
    }

    .menus {
      display: flex;
      padding: 24px 0;

      ol {
        list-style-type: none;
        margin: 0 48px;

        li {
          padding: 10px 0;
          font-size: 0.9em;
          cursor: pointer;
          transition: color 0.1s ease-in-out;
          letter-spacing: 1px;

          &:hover {
            color: var(--color-primary);
          }
        }
      }
    }

    .copyright {
      color: #a3a3a3;
      font-weight: 300;
      font-size: 0.7em;
    }
  }
}

@media (max-width: 992px) {
  .app-footer {
    &__bottom {
      .text {
        text-align: center;
      }

      .menus {
        justify-content: center;
      }
    }
  }
}
</style>
